__turbopack_context__.v({
  "code-error": "coupon-form-module-scss-module__eawvlq__code-error",
  "coupon-form-group": "coupon-form-module-scss-module__eawvlq__coupon-form-group",
  "submit-button-loading-in-checkout-pane": "coupon-form-module-scss-module__eawvlq__submit-button-loading-in-checkout-pane",
});
